import { render } from "./AlertInbox.vue?vue&type=template&id=159bb4b5&scoped=true"
import script from "./AlertInbox.vue?vue&type=script&lang=js"
export * from "./AlertInbox.vue?vue&type=script&lang=js"

import "./AlertInbox.vue?vue&type=style&index=0&id=159bb4b5&lang=scss&scoped=true"

import exportComponent from "/var/www/likvio.se/html-prod/likvio-fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-159bb4b5"]])

export default __exports__